import { Component, OnInit } from '@angular/core';
import {
  faChevronSquareLeft,
} from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {

  faChevronLeft = faChevronSquareLeft;

  constructor() { }

  ngOnInit(): void {
  }

}
